/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {SupplierBaseContract} from '../../../../api/contracts/supplier-base.contract';
import {CodeFilterModel} from '../../../../../shared/filter/code-filter/code-filter.model';
import {CustomerBaseContract} from '../../../../api/contracts/customer-base.contract';
import {SettlementDataModel} from '../../../../models/settlement-data.model';

export class SettlementMainPageFilterMapper {

    static fromSupplierBaseContractToCodeFilterModel(suppliers: readonly SupplierBaseContract[]): CodeFilterModel[] {
        return suppliers?.map((supplier) => ({
            code: supplier.code,
            active: supplier.active,
            name: supplier.name,
            checked: true
        })) ?? [];
    }

    static fromCustomerBaseContractToCodeFilterModel(suppliers: readonly CustomerBaseContract[]): CodeFilterModel[] {
        return suppliers?.map((supplier) => ({
            code: supplier.code,
            active: supplier.active,
            name: supplier.name,
            checked: true
        })) ?? [];
    }

    static fromSettlementDataModelToCodeFilterModel(statuses: readonly SettlementDataModel[]): CodeFilterModel[] {
        return statuses?.map((status) => ({
            code: status.code,
            active: status.active,
            name: status.name,
            checked: true
        })) ?? [];
    }
}
